module.exports = __webpack_public_path__ + "img/brightness-alt-low-fill.0cfedc11.svg";